import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';
import { Truck } from '../materials/trucks';

export interface DailyTruck {
    _id: string;
    activityId: string;
    truckId: Truck;
    isUsed?: boolean;
    price?: number;
    priceType?: number;
    unitPrice?: number;
    createdAt?: string;
    updatedAt?: string;
    quantity: number;
}

export interface DailyTruckResponse {
    message: string;
    data: DailyTruck;
}

export interface DailyTrucksListResponse {
    message: string;
    data: DailyTruck[];
}

export interface CreateDailyTruckBody {
    activityId: string;
    truckId: string;
    isUsed?: boolean;
    price?: number;
    priceType?: number;
    unitPrice?: number;
    quantity?: number;
}

// ---- CREATE DailyTruck ----
export const createDailyTruck = async (body: CreateDailyTruckBody): Promise<DailyTruckResponse> => {
    try {
        const response: AxiosResponse<DailyTruckResponse> = await apiClient.post('/daily-trucks', body);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};

export interface UpdateDailyTruckBody {
    activityId?: string;
    truckId?: string;
    isUsed?: boolean;
    price?: number | null;
    priceType?: number | null;
    unitPrice?: number | null;
    quantity?: number | null;
}

// ---- UPDATE DailyTruck ----
export const updateDailyTruck = async (id: string, body: UpdateDailyTruckBody): Promise<DailyTruckResponse> => {
    try {
        const response: AxiosResponse<DailyTruckResponse> = await apiClient.patch(`/daily-trucks/${id}`, body);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};

export interface UpdateDailyTrucksPriceBatchBody {
    ids: string[];
    unitPrice?: number | null;
    priceType?: number | null;
}

export interface UpdateDailyTrucksPriceBatchResponse {
    message: string;
    data: DailyTruck[];
}

export const updateDailyTrucksPriceBatch = async (body: UpdateDailyTrucksPriceBatchBody): Promise<UpdateDailyTrucksPriceBatchResponse> => {
    try {
        const response: AxiosResponse<UpdateDailyTrucksPriceBatchResponse> = await apiClient.patch('/daily-trucks/prices', body);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};

// ---- DELETE DailyTruck ----
export const deleteDailyTruck = async (id: string): Promise<DailyTruckResponse> => {
    try {
        const response: AxiosResponse<DailyTruckResponse> = await apiClient.delete(`/daily-trucks/${id}`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};
